import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CurrencyInput } from "@/components/ui/currency-input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogHeader, DialogBody, DialogFooter } from "@/components/ui/dialog";
import { AdminDialogHeading } from "@/components/admin/AdminDialogHeading";
import { Money } from "@phosphor-icons/react";

export function AdjustDialog({
  open,
  onClose,
  onSubmit,
  isPending,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { amount: number; note: string }) => void;
  isPending: boolean;
}) {
  const [amount, setAmount] = useState<number | null>(null);
  const [note, setNote] = useState("");
  const valid = amount !== null && amount !== 0 && note.trim().length > 0;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <AdminDialogHeading
          icon={Money}
          title="Ručna korekcija"
          description="Pozitivan iznos povećava, negativan smanjuje stanje."
          tone="warning"
        />
      </DialogHeader>
      <DialogBody>
        <div className="flex flex-col gap-3">
          <p className="text-xs text-muted-foreground">
            Napomena je obavezna.
          </p>
          <div>
            <label className="text-xs font-semibold text-muted-foreground">Iznos (+/–)</label>
            <CurrencyInput
              value={amount}
              onChange={setAmount}
              allowNegative
              placeholder="npr. -50,00 ili 100,00"
              autoFocus
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-muted-foreground">Napomena (obavezno)</label>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="razlog korekcije"
            />
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} disabled={isPending}>
          Otkaži
        </Button>
        <Button disabled={!valid || isPending} onClick={() => onSubmit({ amount: amount!, note: note.trim() })}>
          Sačuvaj
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
